export interface CustomerParams {
    name: string
    address: string
    phone: string
    contact: string
    comment: string
    active: boolean
    permissionDoorOpener: boolean
    permissionGlobalSearch: boolean
    permissionInfoModule: boolean
    permissionDigitalLicenses: boolean
}

export interface Customer {
    id: number
    navn: string
    adresse: string
    telefon: string
    kontakt: string
    kommentar: string
    active: boolean
    permissionDoorOpener: boolean
    permissionGlobalSearch: boolean
    permissionInfoModule: boolean
    permissionDigitalLicenses: boolean
}

export class Customer implements Customer {
    constructor(id: number = 0, name: string = "", address: string = "", phone: string = "", contact: string = "", comment: string = "", active: boolean = true,
        permissionDoorOpener: boolean = false, permissionGlobalSearch: boolean = false, permissionInfoModule: boolean = false, permissionDigitalLicenses: boolean = false)
    {
        this.id = id
        this.navn = name
        this.adresse = address
        this.telefon = phone
        this.kontakt = contact
        this.kommentar = comment
        this.active = active
        this.permissionDoorOpener = permissionDoorOpener
        this.permissionGlobalSearch = permissionGlobalSearch
        this.permissionInfoModule = permissionInfoModule
        this.permissionDigitalLicenses = permissionDigitalLicenses
    }
}

export interface CustomersResponse {
    version: string
    id: string
    result: Customer[]
}

export class CustomersResponse implements CustomersResponse {
    constructor(version: string = "", id: string = "", result: Customer[] = []) {
        this.version = version
        this.id = id
        this.result = result
    }
}

export interface TerminalChange {
    id: number
    terminalId: string
    passphrase: string
    useCount: number
    rsyncUrl: string
    expires: Date
}

export class TerminalChange implements TerminalChange {
    constructor(id: number = 0, terminalId: string = "", passphrase: string = "", useCount: number = 1, expires: Date = new Date(), rsyncUrl: string = "") {
        this.id = id
        this.terminalId = terminalId
        this.passphrase = passphrase
        this.useCount = useCount
        this.rsyncUrl = rsyncUrl
        this.expires = expires
    }
}

export interface TerminalChangesResponse {
    version: string
    id: string
    result: TerminalChange[]
}

export class TerminalChangesResponse implements TerminalChangesResponse {
    constructor(version: string = "", id: string = "", result: TerminalChange[] = []) {
        this.version = version
        this.id = id
        this.result = result
    }
}
